module.exports = __webpack_public_path__ + "static/media/PARIAH_STATE.752c6ec1.png";